import {
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

import {
  NUTRITION_MOUSE_DRAG_START_DISTANCE_PX,
  NUTRITION_TOUCH_DRAG_START_DELAY_MS,
  NUTRITION_TOUCH_DRAG_START_TOLERANCE_PX,
} from "./nutritionTouchDragActivation";

export function useNutritionDragSensors() {
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: NUTRITION_TOUCH_DRAG_START_DELAY_MS,
      tolerance: NUTRITION_TOUCH_DRAG_START_TOLERANCE_PX,
    },
  });

  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: NUTRITION_MOUSE_DRAG_START_DISTANCE_PX,
    },
  });

  const keyboardSensor = useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates,
  });

  return useSensors(touchSensor, mouseSensor, keyboardSensor);
}

export default useNutritionDragSensors;
